export default "__VITE_ASSET__d8aae139__"